.buttons {
    margin-top: 16px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
}
